import rxios from '../common/rxios'
import { merge, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { filter, join, map as _map } from 'lodash-es'

export const serviceHierarhcyService = {
  getServiceGnbHierarchy$() {
    return merge(
      of(require('./json/getServiceGnbHierarchy$.json$').hierarchy),
      rxios.get(`${domain.homepage}/homepage/v1/services/gnb/hierarchies`).pipe(map(response => response.data.hierarchy))
    )
  },
  getServiceMainHierarchyList$() {
    return merge(
      of(require('./json/getServiceMainHierarchyList$.json$').hierarchyList),
      rxios.get(`${domain.homepage}/homepage/v1/services/main/hierarchies`).pipe(map(response => response.data.hierarchyList))
    )
  },
  getServiceLnbHierarchyList$() {
    return merge(
      of(require('./json/getServiceLnbHierarchyList$.json$').hierarchyList),
      rxios.get(`${domain.homepage}/homepage/v1/services/lnb/hierarchies`).pipe(map(response => response.data.hierarchyList))
    )
  },
  getServiceOverviewHierarchyList$() {
    return rxios.get(`${domain.homepage}/homepage/v1/services/overview/hierarchies`).pipe(map(response => response.data.hierarchy))
  },
  getServiceMenuClass(service) {
    return join(trimServiceMenuBadge(service), ' ')
  },
  getServiceMenuClassArray(service) {
    return trimServiceMenuBadge(service)
  },
  getServiceOverviewBadgeClass(service) {
    return join(trimServiceOverviewBadge(service), ' ')
  },
  getServiceOverviewBadgeClassArray(service) {
    return trimServiceOverviewBadge(service)
  },
  isCertificationService(service) {
    return trimServiceMenuBadge(service).includes('is_csap')
  }
}
function trimServiceMenuBadge(service) {
  return _map(service.badges, badge => `is_${badge.trim()}`)
}
function trimServiceOverviewBadge(service) {
  const badges = _map(service.badges, badge => badge.trim())
  const filterd = filter(badges, badge => badge.trim() === 'beta' || badge.trim() === 'alpha' || badge.trim() === 'csap')
  return _map(filterd, badge => `is_${badge}`)
}
